import {useStore} from 'zustand';
import {useShallow} from 'zustand/react/shallow';

import {
  selectWBAgentBillingAccess,
  type WBAgentBillingAccess,
  type WBAgentBillingState,
} from './access';
import {billingStore} from './store';

/**
 * useWBAgentBilling returns the full billing state, useful for reading the
 * quota numbers. To gate access, use useWBAgentBillingAccess.
 */
export function useWBAgentBilling(): WBAgentBillingState {
  return useStore(billingStore.store);
}

/** useWBAgentBillingAccess returns the verdict to gate access on. */
export function useWBAgentBillingAccess(): WBAgentBillingAccess {
  // NOTE: useShallow memoizes the fresh object returned each call.
  return useStore(billingStore.store, useShallow(selectWBAgentBillingAccess));
}
